// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b409dadd","320":"5d4658f0","455":"083a503c","935":"578050f2"}[chunkId] + ".chunk.js";
};